module.exports = __webpack_public_path__ + "img/moneypending.9bc5d158.png";